/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["crupdate-review-modal{display:block;width:500px;max-width:100%}crupdate-review-modal star-rating-widget{margin-left:-10px}"];
export { styles as styles };
